module.exports = __webpack_public_path__ + "static/photo_concept-2bc1c3e23aaa1ab8f36fdcfcf8e9cddb.jpg";